import { MODAL_SIZE } from "./PAModal";
import PAModalMultipleView from "./bottom-sheet/PAModalMultipleView";

function BottomSheetWrapper(props) {
  const {
    title, titleClass = "", view = "fromBottom", size = MODAL_SIZE.MEDIUM, onHide, children, hasDropdown = false,
    persistent = false, modalBodyClassName = "", showHeader = true, showTopRightCloseButton = true, headerClass = "",
    showWhite = "", dialogClass = "", closeButtonClass = "",
  } = props;

  return (
    <PAModalMultipleView
      size={size}
      header={{
        title,
        titleClass,
        closeButton: !persistent,
        closeButtonClass,
      }}
      show
      onHide={onHide}
      view={view}
      hasDropdown={hasDropdown}
      persistent={persistent}
      modalBodyClassName={modalBodyClassName}
      showHeader={showHeader}
      showTopRightCloseButton={showTopRightCloseButton}
      headerClass={headerClass}
      showWhite={showWhite}
      dialogClass={dialogClass}
    >
      {children}

    </PAModalMultipleView>
  );
}

export default BottomSheetWrapper;
